;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export var InternalArticleType;
(function (InternalArticleType) {
    InternalArticleType["UNKNOWN"] = "UNKNOWN";
    InternalArticleType["ARTICLE"] = "ARTICLE";
    InternalArticleType["FEATURE_REQUEST"] = "FEATURE_REQUEST";
    InternalArticleType["KNOWN_ISSUE"] = "KNOWN_ISSUE";
    InternalArticleType["VIDEO"] = "VIDEO";
})(InternalArticleType || (InternalArticleType = {}));
;
;
;
;
export var ManagementTypeEnumManagementType;
(function (ManagementTypeEnumManagementType) {
    ManagementTypeEnumManagementType["UNKNOWN"] = "UNKNOWN";
    ManagementTypeEnumManagementType["POINTING"] = "POINTING";
    ManagementTypeEnumManagementType["DNS"] = "DNS";
    ManagementTypeEnumManagementType["REGISTRATION"] = "REGISTRATION";
    ManagementTypeEnumManagementType["POINTING_GOOGLE"] = "POINTING_GOOGLE";
    ManagementTypeEnumManagementType["POINTING_REG_RU"] = "POINTING_REG_RU";
    ManagementTypeEnumManagementType["POINTING_MSO_365"] = "POINTING_MSO_365";
    ManagementTypeEnumManagementType["PHOTOGRAPHERS"] = "PHOTOGRAPHERS";
})(ManagementTypeEnumManagementType || (ManagementTypeEnumManagementType = {}));
export var ConnectivityStatus;
(function (ConnectivityStatus) {
    ConnectivityStatus["UNKNOWN"] = "UNKNOWN";
    ConnectivityStatus["OK"] = "OK";
    ConnectivityStatus["MISSING_RECORDS"] = "MISSING_RECORDS";
    ConnectivityStatus["INVALID_RECORDS"] = "INVALID_RECORDS";
    ConnectivityStatus["PROPAGATION"] = "PROPAGATION";
    ConnectivityStatus["REDUNDANT_NS"] = "REDUNDANT_NS";
})(ConnectivityStatus || (ConnectivityStatus = {}));
;
;
export var UserSuccessLockReason;
(function (UserSuccessLockReason) {
    UserSuccessLockReason["CRISIS_MODE"] = "crisis mode";
    UserSuccessLockReason["PARTNER"] = "policy - partners";
    UserSuccessLockReason["SUCCESSFUL_USER"] = "policy - successful user";
})(UserSuccessLockReason || (UserSuccessLockReason = {}));
;
;
;
;
;
export var PlanPurchaseProvider;
(function (PlanPurchaseProvider) {
    PlanPurchaseProvider["UNKNOWN_PURCHASE_PROVIDER"] = "UNKNOWN_PURCHASE_PROVIDER";
    PlanPurchaseProvider["WIX"] = "WIX";
    PlanPurchaseProvider["CLIENT_SUBSCRIPTION"] = "CLIENT_SUBSCRIPTION";
    PlanPurchaseProvider["RESELLER"] = "RESELLER";
})(PlanPurchaseProvider || (PlanPurchaseProvider = {}));
export var PlanSubscriptionStatus;
(function (PlanSubscriptionStatus) {
    PlanSubscriptionStatus["UNKNOWN_SUBSCRIPTION_STATUS"] = "UNKNOWN_SUBSCRIPTION_STATUS";
    PlanSubscriptionStatus["ACTIVE"] = "ACTIVE";
    PlanSubscriptionStatus["NOT_ACTIVE"] = "NOT_ACTIVE";
    PlanSubscriptionStatus["WILL_EXPIRE"] = "WILL_EXPIRE";
    PlanSubscriptionStatus["EXPIRED"] = "EXPIRED";
    PlanSubscriptionStatus["CANCELLED"] = "CANCELLED";
})(PlanSubscriptionStatus || (PlanSubscriptionStatus = {}));
export var PlanInvoiceStatus;
(function (PlanInvoiceStatus) {
    PlanInvoiceStatus["UNKNOWN_INVOICE_STATUS"] = "UNKNOWN_INVOICE_STATUS";
    PlanInvoiceStatus["DUE"] = "DUE";
    PlanInvoiceStatus["CLOSED"] = "CLOSED";
    PlanInvoiceStatus["VOID"] = "VOID";
    PlanInvoiceStatus["BAD_DEBT"] = "BAD_DEBT";
    PlanInvoiceStatus["REFUNDED"] = "REFUNDED";
    PlanInvoiceStatus["DECLINED_CHARGES"] = "DECLINED_CHARGES";
    PlanInvoiceStatus["ERROR_CHARGES"] = "ERROR_CHARGES";
    PlanInvoiceStatus["CREDIT_NOTE"] = "CREDIT_NOTE";
    PlanInvoiceStatus["PAYMENT_IN_PROGRESS"] = "PAYMENT_IN_PROGRESS";
    /** Billing system status: VOID or Unknown type */
    PlanInvoiceStatus["UNKNOWN_PAYMENT_STATUS"] = "UNKNOWN_PAYMENT_STATUS";
    /** Billing system status: Closed */
    PlanInvoiceStatus["PAID"] = "PAID";
    /** Billing system invoice status: CREDIT_NOTE, ERROR_CHARGES, DECLINED_CHARGES , BAD_DEBT */
    PlanInvoiceStatus["CHARGE_FAILURE"] = "CHARGE_FAILURE";
    /** Billing system invoice status = Due , PAYMENT_IN_PROGRESS */
    PlanInvoiceStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Invoice was never created for asset, mostly transferred assets */
    PlanInvoiceStatus["NO_PAYMENT"] = "NO_PAYMENT";
    /** Manual_payment_pending? */
    PlanInvoiceStatus["NOT_BILLABLE"] = "NOT_BILLABLE";
})(PlanInvoiceStatus || (PlanInvoiceStatus = {}));
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["UNKNOWN_PAYMENT_CYCLE"] = "UNKNOWN_PAYMENT_CYCLE";
    BillingCycle["ONE_TIME"] = "ONE_TIME";
    BillingCycle["DAILY"] = "DAILY";
    BillingCycle["WEEKLY"] = "WEEKLY";
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["QUARTERLY"] = "QUARTERLY";
    BillingCycle["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["TWO_YEARS"] = "TWO_YEARS";
    BillingCycle["THREE_YEARS"] = "THREE_YEARS";
    BillingCycle["FOUR_YEARS"] = "FOUR_YEARS";
    BillingCycle["FIVE_YEARS"] = "FIVE_YEARS";
})(BillingCycle || (BillingCycle = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CancellationReason;
(function (CancellationReason) {
    CancellationReason["UNKNOWN_CANCEL_REASON"] = "UNKNOWN_CANCEL_REASON";
    CancellationReason["USER_INITIATED"] = "USER_INITIATED";
    CancellationReason["BACKOFFICE_CANCEL"] = "BACKOFFICE_CANCEL";
    CancellationReason["PAYMENT_PROBLEMS"] = "PAYMENT_PROBLEMS";
    CancellationReason["CHARGEBACK"] = "CHARGEBACK";
    CancellationReason["REFUND_WIDGET"] = "REFUND_WIDGET";
    CancellationReason["RECURRING_TASK"] = "RECURRING_TASK";
    CancellationReason["MANUAL_RECURRING_EXPIRED"] = "MANUAL_RECURRING_EXPIRED";
    CancellationReason["CHANGE_PLAN"] = "CHANGE_PLAN";
    CancellationReason["TRANSFER_SITE"] = "TRANSFER_SITE";
    CancellationReason["SITE_DELETION"] = "SITE_DELETION";
    CancellationReason["REQUESTED_BY_MANAGING_APP"] = "REQUESTED_BY_MANAGING_APP";
})(CancellationReason || (CancellationReason = {}));
export var addQueryParam = function (key, value) {
    if (value === null || value === undefined) {
        return '';
    }
    var encodedKey = encodeURIComponent(String(key));
    var encodedValue = encodeURIComponent(String(value));
    return "&".concat(encodedKey, "=").concat(encodedValue);
};
var BO_PATH = 'https://bo.wix.com/_serverless/expert-toolkit';
export var getExpertToolkitApiUrl = function () { return BO_PATH; };
export var createExpertToolkitApi = function (http) {
    var api = {
        searchUserAccountsByEmail: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/searchUserAccountsByEmail"), dto);
        },
        searchUserAccountsByUserId: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/searchUserAccountsByUserId"), dto);
        },
        getUserInfo: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserInfo?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId));
        },
        checkVpn: function () {
            var fetchVpnStatus = http.get("".concat(getExpertToolkitApiUrl(), "/checkVpn"));
            var timeout = new Promise(function (resolve) {
                setTimeout(function () {
                    resolve({ enabled: false });
                }, 3000);
            });
            return Promise.race([fetchVpnStatus, timeout]);
        },
        getUserEssentials: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserEssentials?accountId=").concat(dto.accountId, "&userId=").concat(dto.userId, "&ticketId=").concat(dto.ticketId));
        },
        getAccountDetails: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserAccountDetails?accountId=").concat(dto.accountId, "&userId=").concat(dto.userId));
        },
        getTicketBrief: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getTicketBrief?ticketId=").concat(dto.ticketId, "&accountId=").concat(dto.accountId, "&userId=").concat(dto.userId));
        },
        getUserTicketHistoryStats: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserTicketHistoryStats?ticketId=").concat(dto.ticketId));
        },
        getUserTicketHistory: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/searchUserTicketHistory"), dto);
        },
        getTicketTechnicalData: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getTechnicalData?ticketId=").concat(dto.ticketId));
        },
        getUserSites: function (dto) {
            var searchPhrase = addQueryParam('searchPhrase', dto.searchPhrase);
            var pageSize = addQueryParam('pageSize', dto.pageSize);
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserSitesByAccount?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId).concat(searchPhrase).concat(pageSize));
        },
        getSiteBoLinks: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getSiteBoLinks?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId, "&metaSiteId=").concat(dto.metaSiteId));
        },
        getSiteData: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserSiteInfo?userId=").concat(dto.userId, "&accountId=").concat(dto.accountId, "&msid=").concat(dto.siteId));
        },
        queryExpertAssistant: function (dto) {
            var encodedQuery = encodeURIComponent(dto.query);
            return http.get("".concat(getExpertToolkitApiUrl(), "/expertAssistant/query?query=").concat(encodedQuery, "&userId=").concat(dto.userId, "&aiVersion=").concat(dto.aiVersion));
        },
        getInternalRelatedDocs: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/expertAssistant/getInternalRelatedDocs"), dto);
        },
        getDomainInfo: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/domainInfo?name=").concat(dto.name, "&accountId=").concat(dto.accountId));
        },
        getUserDomains: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/userDomains?accountId=").concat(dto.accountId));
        },
        getUserSuccessLockState: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getUserSuccessLockState?accountId=").concat(dto.accountId, "&ticketAssignedGroupId=").concat(dto.ticketAssignedGroupId, "&ticketChannel=").concat(dto.ticketChannel));
        },
        getEscalationForm: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getEscalationForm?topicId=").concat(dto.topicId));
        },
        createExpertFeedback: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/expertFeedback"), dto);
        },
        getExpertFeedbackForm: function (dto) {
            return http.get("".concat(getExpertToolkitApiUrl(), "/getExpertFeedbackForm?expertOrganization=").concat(dto.expertOrganization));
        },
        assignImpersonationRoleToAgent: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/assignImpersonationRoleToAgent?email=").concat(dto.email), dto);
        },
        deleteImpersonationRoleToAgent: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/deleteImpersonationRoleToAgent?email=").concat(dto.email), dto);
        },
        searchPlans: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/plans"), dto);
        },
        queryInternal: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/expertAssistant/queryInternal"), dto);
        },
        searchAccountPremiumAssets: function (dto) {
            return http.post("".concat(getExpertToolkitApiUrl(), "/searchAccountPremiumAssets"), dto);
        }
    };
    return api;
};
export * from './user-account-Info.builder';
export * from './account-Info.builder';
export * from './account-details.builder';
export * from './ticket-technical-data.builder';
export * from './user-site-data-builder';
export * from './site-data.builder';
export * from './doc-metadata.builder';
export * from './query-result-source.builder';
export * from './escalation-form.builder';
export * from './stores-internal-note.builder';
export * from './plan.builder';
export * from './plan-invoice-details.builder';
//# sourceMappingURL=index.js.map